<template>
    <div class="admin">
        <div class="search">
            <Button type="primary" icon="md-add" @click="editModal({})">
                <span>{{$t('add')}}{{$t('admin')}}</span>
            </Button>
        </div>
        <Table border :columns="columns12" :data="data6">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" style="margin-right: 5px" @click="editModal(row)">{{$t('edit')}}</Button>
                <Button type="error" size="small" @click="delModal(row);">{{$t('del')}}</Button>
            </template>
        </Table>
        
        <div class="page">
            <Page :total="totalItems" :page-size="itemsPerPage" show-elevator :current="currentPage" @on-change="loadData" />
        </div>

        <Modal v-model="showEditModal" :title="$t('edit')+$t('admin')" @on-ok="editOk">
            <Form :model="formItem" :label-width="100">
                <FormItem :label="$t('username')">
                    <Input v-model="formItem.username"></Input>
                </FormItem>
                <FormItem :label="$t('password')">
                    <Input v-model="newPass"></Input>
                </FormItem>
                <FormItem :label="$t('confirm')+$t('password')">
                    <Input v-model="newPass2"></Input>
                </FormItem>
                <FormItem :label="$t('type')">
                    <Select v-model="formItem.level_str" style="width:200px">
                        <Option value="2">{{$t('super')}}{{$t('admin')}}</Option>
                        <Option value="1">{{$t('admin')}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('status')">
                    <RadioGroup v-model="formItem.status_str">
                        <Radio label="1">{{$t('agent.status1')}}</Radio>
                        <Radio label="0">{{$t('agent.status0')}}</Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
        </Modal>
        
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="showDelModal=false;deleteAdmin(formItem);"
            @on-cancel="showDelModal=false">
            <p>{{$t('confirmDel')}}</p>
        </Modal>

    </div>
</template>
<script>
export default {
    mounted() {
        this.loadData(1);
    },
    data() {
        return {
            showEditModal: false,
            showDelModal: false,
            showAddModal: false,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            newPass: '',
            newPass2: '',
            formItem: {},
            columns12: [
                {
                    title: "ID",
                    key: "id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "username"
                },
                {
                    title: this.$i18n.t('type'),
                    key: "level",
                    render: (h, params) => {
                        return h('span', params.row.level == 2 ? this.$i18n.t('super')+this.$i18n.t('admin') : this.$i18n.t('admin'));
                    }
                },
                {
                    title: this.$i18n.t('super')+this.$i18n.t('login')+this.$i18n.t('time'),
                    key: "last_login_at"
                },
                {
                    title: this.$i18n.t('status'),
                    key: "status",
                    render: (h, params) => {
                        return h('span', params.row.status == 1 ? this.$i18n.t('agent.status1') : this.$i18n.t('agent.status0'));
                    }
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 200,
                    align: "center"
                }
            ],
            data6: []
        };
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.admin, {
                page: this.currentPage
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list.map(item => {
                        item.status_str = '' + item.status;
                        item.level_str = '' + item.level;
                        return item;
                    });
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        deleteAdmin(row) {
            this
                .$post(this.$path.admin_del, this.formItem)
                .then(res => {
                    if (res.success) {
                        this.$Message.success(this.$i18n.t('operateSuccess'));
                        this.loadData(this.currentPage);
                    } else {
                        this.$Message.error(this.$i18n.t('operateFailed'));
                    }
                });
        },
        delModal(row) {
            this.formItem = row;
            this.showDelModal = true;
        },
        editModal(row) {
            this.formItem = row;
            this.showEditModal = true;
        },
        editOk() {
            this.formItem.status = Number(this.formItem.status_str);
            this.formItem.level = Number(this.formItem.level_str);
            if (this.newPass && this.newPass !== this.newPass2) {
                return this.$Message.error(this.$i18n.t('twoPassword'));
            }
            if (this.newPass) {
                this.formItem.password = this.newPass;
                this.formItem.pass = this.newPass;
            } else {
                this.formItem.password = undefined;
                this.formItem.pass = undefined;
            }
            this
                .$post(this.formItem.id ? this.$path.admin_edit : this.$path.admin_add, this.formItem)
                .then(res => {
                    if (res.success) {
                        this.$Message.success(this.$i18n.t('operateSuccess'));
                    } else {
                        this.$Message.error(this.$i18n.t('operateFailed'));
                    }
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/admin.vue